import React from 'react';
import cn from 'classnames';
import './burger.scss';


const BurgerButton = (props) => {
  const classes = cn('hamburger hamburger--elastic', {
    'is-active': props.active,
  })
  return (
    <button
      className={classes}
      type="button"
      aria-label="Menu"
      aria-controls={props.controls}
      onClick={props.onClick}
    >
      <span className="hamburger-box">
        <span className="hamburger-inner"></span>
      </span>
    </button>
  )
};

export default BurgerButton;




// WEBPACK FOOTER //
// ./src/components/MainHeader/BurgerButton.js